export const isNotDefined = (value: unknown): value is null | undefined => value === null || value === undefined;

// is replacement for previous value != null comparison
export const isDefined = <T>(value: T): value is NonNullable<T> => value !== null && value !== undefined;
